// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset } from "@insite/mobius/GridContainer";
import { staticListProductListLineStyles } from "@pace/Overrides/Widgets/StaticList/StaticListProductListLine";
import { css } from "styled-components";

staticListProductListLineStyles.priceAndAvailabilityInnerContainer = {
    gap: 10,
    offsetCss: css`
        flex-direction: row-reverse;
    `,
};

staticListProductListLineStyles.productAvailabilityStyles = {
    container: {
        css: css`
            padding-top: 10px;
            & > ${GridOffset} {
                flex-direction: column;
                align-items: flex-start;
            }
        `,
    },
    buttonsContainer: {
        css: css`
            align-items: flex-start;
        `,
    },
};
staticListProductListLineStyles.descriptionGridItem = {
    width: [8, 8, 4, 4, 4],
    printWidth: 6,
    css: css`
        flex-direction: column;
        gap: 10px;
    `,
};
staticListProductListLineStyles.productPartNumbersStyles = {
    erpNumberGridItem: {
        css: css`
            flex-direction: row;
        `,
    },
    erpNumberLabelText: { variant: "legend" },
    customerNameGridItem: {
        css: css`
            flex-direction: row;
        `,
    },
    customerNameLabelText: { variant: "legend" },
    manufacturerItemGridItem: {
        css: css`
            flex-direction: row;
        `,
    },
    manufacturerItemLabelText: { variant: "legend" },
};
